import {api} from "api";
import {State} from "./types";
import {showAlert} from "../alert";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {thunkBadRequest} from "global/thunk-error";
import {setRequestStatus} from "../request-status";
import {toggleButtonLoaderId, togglePanel} from "../layout";
import {setPaymentsPagination, setPaymentsSliceRequestStatus} from ".";
import {
  BankModel,
  PaymentModel,
  ReportPaymentPayload,
  UpdatePaymentStatusPayload,
} from "interfaces";
import {postFormData} from "utils";

export const get = createAsyncThunk(
  "payments/get",
  async (pagination: State["pagination"], {dispatch, rejectWithValue}) => {
    const {refresh = false, pos, lim, ser, hasMore} = pagination;
    dispatch(setPaymentsPagination({pos, lim, ser, hasMore}));
    if (refresh) {
      dispatch(
        setPaymentsSliceRequestStatus({
          name: "payments",
          status: setRequestStatus("initial"),
        }),
      );
    }

    try {
      const data = (
        await api.Get<{
          rows: PaymentModel[];
          count: number;
        }>(`/payment_reports/getAll?position=${pos}&limit=${lim}&search=${ser}`)
      )["data"];
      return {data, refresh};
    } catch (error) {
      thunkBadRequest(dispatch, error);
      return rejectWithValue(error);
    }
  },
);

export const updatePaymentStatus = createAsyncThunk(
  "payments/update-payment-status",
  async (payload: UpdatePaymentStatusPayload, {dispatch, rejectWithValue}) => {
    try {
      const {data} = await api.Post<PaymentModel>(
        "/payment_reports/changeStatus",
        payload,
      );
      dispatch(showAlert({type: "success", title: "Pago actualizado"}));
      return data;
    } catch (error) {
      thunkBadRequest(dispatch, error);
      return rejectWithValue(error);
    }
  },
);

export const getBanks = createAsyncThunk(
  "payments/get-banks",
  async (_, {dispatch, rejectWithValue}) => {
    try {
      return (await api.Get<BankModel[]>("/payment_reports/banks"))["data"];
    } catch (error) {
      thunkBadRequest(dispatch, error);
      return rejectWithValue(error);
    }
  },
);

export const reportPayment = createAsyncThunk(
  "payments/report-payment",
  async (payload: ReportPaymentPayload, {rejectWithValue, dispatch}) => {
    dispatch(toggleButtonLoaderId("report-payment"));

    const formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
      formData.append(key, value);
    }

    try {
      await postFormData("/payment_reports/update", formData);
      dispatch(togglePanel({type: "close"}));
      dispatch(
        showAlert({
          type: "success",
          title: "El reporte de pago ha sido enviado con éxito",
        }),
      );
    } catch (error) {
      thunkBadRequest(dispatch, error);
      return rejectWithValue(error);
    } finally {
      dispatch(toggleButtonLoaderId("report-payment"));
    }
  },
);
